/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Prize pool information display
 * @export
 * @interface UpdateCompetitionBodyOnboardingSectionPrizePool
 */
export interface UpdateCompetitionBodyOnboardingSectionPrizePool {
    /**
     * 
     * @type {string}
     * @memberof UpdateCompetitionBodyOnboardingSectionPrizePool
     */
    header?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompetitionBodyOnboardingSectionPrizePool
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompetitionBodyOnboardingSectionPrizePool
     */
    icon?: string;
}

/**
 * Check if a given object implements the UpdateCompetitionBodyOnboardingSectionPrizePool interface.
 */
export function instanceOfUpdateCompetitionBodyOnboardingSectionPrizePool(value: object): value is UpdateCompetitionBodyOnboardingSectionPrizePool {
    return true;
}

export function UpdateCompetitionBodyOnboardingSectionPrizePoolFromJSON(json: any): UpdateCompetitionBodyOnboardingSectionPrizePool {
    return UpdateCompetitionBodyOnboardingSectionPrizePoolFromJSONTyped(json, false);
}

export function UpdateCompetitionBodyOnboardingSectionPrizePoolFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCompetitionBodyOnboardingSectionPrizePool {
    if (json == null) {
        return json;
    }
    return {
        
        'header': json['header'] == null ? undefined : json['header'],
        'description': json['description'] == null ? undefined : json['description'],
        'icon': json['icon'] == null ? undefined : json['icon'],
    };
}

export function UpdateCompetitionBodyOnboardingSectionPrizePoolToJSON(json: any): UpdateCompetitionBodyOnboardingSectionPrizePool {
    return UpdateCompetitionBodyOnboardingSectionPrizePoolToJSONTyped(json, false);
}

export function UpdateCompetitionBodyOnboardingSectionPrizePoolToJSONTyped(value?: UpdateCompetitionBodyOnboardingSectionPrizePool | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'header': value['header'],
        'description': value['description'],
        'icon': value['icon'],
    };
}

